
import { GridLayoutHeader } from '../../../../../constants';
import { FlexLayout } from '../../../../../components/layout/FlexLayout';
import { FloorModel } from '../models';
import { BreakAnalysisAll } from '../BreakAnalysisAll';
import { TextBox } from '../../../../../components';

// 층수별
const Floor: GridLayoutHeader<FloorModel, BreakAnalysisAll>[] = [
  {
    id: 'number',
    text: '층수별',
    width: 100,
    trail: () => (
      <FlexLayout
        justify="left"
        align="center"
      >
        총계
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {x.number}
      </FlexLayout>
    ),
  },
  {
    id: 'tot',
    text: '고장건수',
    width: 10,
    trail: (_, scope) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {scope?.state?.tot_tot}건
      </FlexLayout>
    ),
    render: (x) => (
      <TextBox
        textAlign="center"
        value={x.tot}
      />
    ),
  },
];

export default Floor;
